import SymbolAnimation from "../symbols/SymbolAnimation";
import BaseSymbolsAnimationsContainer from "Engine/slots/symbolsAnimations/BaseSymbolsAnimationsContainer";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import GameModel from "../model/GameModel"
import Utils from "Engine/Utils";
import EntryPoint from "Engine/EntryPoint";
import SoundManager from "Engine/soundManager/SoundManager";

export default class SymbolsAnimationsContainer extends BaseSymbolsAnimationsContainer {
    constructor(data, displayData) {
        super(data, displayData);
    }

    init() {
        super.init();
        this.startX = this.x;
        this.startY = this.y;
    }

    addListeners() {
        super.addListeners();
        GlobalDispatcher.add('reel:stopped', this.onReelStopped, this);
    }

    changeState(value) {
        /*let scale = value === 1 ? 1 : 0.7678;
        let x = value === 1 ? 332 : 478;
        let y = value === 1 ? 159 : 152; //287 //280
        if (EntryPoint.mobile) {
            y = value === 1 ? 287 : 280;
        }
        this.scale.set(scale, scale);
        this.position.set(x, y);*/

        let scale = value === 1 ? 1 : 0.7678;
        let x = value === 1 ? this.startX : this.startX + 146;
        let y = value === 1 ? this.startY : this.startY - 7;
        this.scale.set(scale, scale);
        this.position.set(x, y);
    }

    showWinningSymbols(data) {
        if (!data.params.hasOwnProperty('line')) {
            SoundManager.play('sounds/mainGame/FreeSpinActivation', 1, false);
        }

        this.removeAnimations();
        data.params.path.forEach((pathData) => {
            this.addAnimation(pathData, 'win', '');
        });
    }

    onReelStopped(event) {
        let reelIndex = event.params - 1;
        let reelData = GameModel.reels[reelIndex];
        reelData.forEach((symbolId, index)=>{
            if (symbolId === 1) {
                this.addAnimation([reelIndex, index], 'scatter_landing','');
            }
        });
    }

    addAnimation(pathData, animationName = 'win', type = '') {
        let reelsOffset = EntryPoint.GameModel.isFreeSpins ? 7 : 6;
        let id = GameModel.reels[pathData[0]][pathData[1]];
        let animation = new SymbolAnimation(id, pathData, type);
        animation.x = pathData[0] * (246 + reelsOffset);
        animation.y = pathData[1] * 246;
        animation.start(animationName);
        this.addChild(animation);
        this.animations.push(animation);

        this.checkForWild(animation, id, pathData);
    }

    checkForWild(animation) {
        if (animation.id !== 2) {
            return;
        }

        GameModel.wilds.forEach((wildsData, index) => {
            if (wildsData.wildCoordinates.x === (animation.symbolPosition[0] + 1) && wildsData.wildCoordinates.y === (animation.symbolPosition[1] + 1)) {
                if (wildsData.multiplier > 1) {
                    animation.changeSkin('x' + wildsData.multiplier);
                }
                if (wildsData.remainingStickyRounds > 0) {
                    animation.changeSkin('lock' + wildsData.remainingStickyRounds);
                }
            }
        });
    }
}